module.exports = __webpack_public_path__ + "img/card-reader-gen2.d2ddd5bc.jpg";